import { GraphQLClient } from 'graphql-request'
import { addHook } from '@viveaesthetics/elemy-shared-core/lib/utils/mockHooks'
import { genericErrorHandler } from '@viveaesthetics/shared-domain'
import { useQueryClient } from '@tanstack/react-query'
import { datadogRum } from '@datadog/browser-rum'

import {
  GetClientPublicProfileDocument,
  GetClientPublicProfileQuery,
  GetClientPublicProfileQueryVariables
} from '@/graphql/generated/schema'
import { publicClient } from '@/graphql/client'

export const useGetClientPublicProfileAsync = addHook({
  useGetClientPublicProfileAsync: () => {
    const queryClient = useQueryClient()

    const getClientPublicProfileAsync = async (email: string) => {
      try {
        const data = await queryClient.fetchQuery({
          queryKey: ['GetClientPublicProfile', email],
          queryFn: fetcher(publicClient, GetClientPublicProfileDocument, {
            email
          })
        })

        let clientNotFound = null
        let error = ''

        if (data?.clients?.getClientPublicProfile) {
          if ('error' in data?.clients?.getClientPublicProfile) {
            const errName =
              data?.clients?.getClientPublicProfile.error.__typename
            if (
              errName === 'ClientNotFoundByEmailError' ||
              errName === 'ClientNotFoundError'
            ) {
              clientNotFound = true
            } else {
              error = data?.clients?.getClientPublicProfile.error.message

              genericErrorHandler(error)
              datadogRum.addError(error)
            }
          }
        }

        return {
          data: { clientNotFound },
          error
        }
      } catch (error) {
        genericErrorHandler(error)
        datadogRum.addError(error)

        return null
      }
    }

    return getClientPublicProfileAsync
  }
})

function fetcher(
  client: GraphQLClient,
  query: string,
  variables: GetClientPublicProfileQueryVariables
) {
  return () =>
    client.request<
      GetClientPublicProfileQuery,
      GetClientPublicProfileQueryVariables
    >(query, variables)
}
